import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ReactModal from "react-modal";
import { unregister } from "./registerServiceWorker";

unregister();

ReactModal.setAppElement("#root");

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js